<template >
<div class = "goods_detail" >
 <van-nav-bar
     :title = "detailContent.title"
     left-text = "返回"
     left-arrow
     @click-left = "onClickLeft"
 />
  <div class = "main" v-html = "detailContent.main" ></div >

</div >
</template >

<script >
import { getGoodDetail } from "@/api/home";
import { getVirtualDetail } from "@/api/virtual";

export default {
  name: "good_detail",
  data () {
    return {
      detailContent: {
        main: '',
        title: "",
        cover:"",
      }
    };
  },
  beforeMount () {
    this.$toast ( {
      type: "loading",
      message: "加载中..."
    } );

    this.$nextTick ( () => {
      const id = this.$route.query.id;
      const type = this.$route.query.type;
      type === "1" ? this.getEntiyGoodInfo ( id ) : this.getVirtualGoodInfo ( id );
    } );
  },

  methods: {
    //获取实体商品
    async getEntiyGoodInfo ( id ) {
      console.log ("实体");
      const { data } = await getGoodDetail ( { goodId: id } );
      if ( data.code !== 200 ) return;
      this.$toast.clear ();
      this.detailContent = {
        ...this.detailContent,
        main: data.data.content,
        title: data.data.goodsName,
      };
    },
    //获取虚拟商品
    async getVirtualGoodInfo ( id ) {
      console.log ("虚拟");

      const { data } = await getVirtualDetail ( { goodId: id} );
      if ( data.code !== 200 ) return;
      this.$toast.clear ();
      this.detailContent = {
        ...this.detailContent,
        main: data.data.content,
        title: data.data.goodsName,
      };
    },
    //回到订单页面
    onClickLeft () {
      this.$router.replace ( "/order" );
    }
  }
};
</script >

<style scoped lang = "less" >
.goods_detail {
  height: 100%;
  width: 100vw;
  .main {
    height: 100%;
    width: 100vw;
    padding: 0 20px 100px;
    box-sizing: border-box;
    overflow: auto;
  }
}
/deep/ video,/deep/img {
  width: 100%;

}
</style >